<div class="scanner-container layout f_col pl_10 pr_10">
  <div id="scanner" class="loader_scan" [class.scanner-hidden]="!hasPermission">
    <div #scanner_wrapper [hidden]="!started" class="scanner_wrapper">
      <div id="scanner_placeholder">
        <div #scanner_square class="scanner_square"></div>
        <div class="scanner_bottom">
          <fa-icon icon="camera-rotate" (click)="nextCamera()" class="scanner_camera"></fa-icon>
        </div>
      </div>
      <div class="zxing-wrapper">
        <zxing-scanner #zscanner
                       [autostart]="autoStart"
                       [(device)]="currentDevice"
                       [previewFitMode]="'cover'"
                       (scanSuccess)="onCodeResult($event)"
                       (scanError)="scanError($event)"
                       (permissionResponse)="onHasPermission($event)"
                       (camerasFound)="onCamerasFound($event)"
                       (autostarted)="autoStarted()"
                       (camerasNotFound)="camerasNotFoundHandler()">
        </zxing-scanner>
      </div>
    </div>
  </div>
  <div class="f_align_end f_grow mb_20 fullWidth resp_maxSize_l">
    <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <div class="ml_10 fullWidth">
      <app-button color="transparent" border="true" formId="form" class="fullWidth" (btnClicked)="nav.to('dashboard')" >{{'global.back' | translate}}</app-button>
    </div>
  </div>
</div>
